import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "通常(専用伝票)" },
  { value: 2, text: "仮伝" },
  { value: 3, text: "伝票無し" },
]);
